import React from "react";

type Props = {
  children: React.ReactNode;
};

const MainPage: React.FC<Props> = (props: Props) => (
  <div id="main" className="w-full bg-background overflow-y-auto scrollbar-thin scrollbar-thumb-[#D9D9D9AA] scrollbar-thumb-rounded-full" style={{scrollbarGutter: 'stable'}}>
    {props.children}
  </div>
);

export default MainPage;
